"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCssProperty = void 0;
/**
 * @internal
 */
exports.getCssProperty = function (key, value) {
    return value && {
        key: "--gd-" + key,
        value: value,
    };
};
//# sourceMappingURL=cssProperty.js.map